module.exports = __webpack_public_path__ + "img/task-m2.7ddd2537.jpeg";